import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {CrudFlagcategoriesService} from '@shared/services/crud-flagcategories.service';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService} from '@shared/services/alert.service';

@Component({
  selector: 'app-flagcategories-edit',
  templateUrl: './flagcategories-edit.component.html',
  styleUrls: ['./flagcategories-edit.component.scss']
})
export class FlagcategoriesEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private flagcategoriesservice: CrudFlagcategoriesService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, flagcategoriesservice, alertService);

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {key: 'id', type: 'input', defaultValue: '', templateOptions: {label: 'ID', readonly: true}},
              {key: 'label', type: 'input', defaultValue: '', templateOptions: {label: 'Category label', required: true}},
              {key: 'flagcategorykey', type: 'input', defaultValue: '', templateOptions: {label: 'Category key', required: true}},
            ]
          }
        ]
      }
    ];

    this.createSectionTitle = 'Create flag category';
    this.updatePrefixTitle = 'Edit flag category:';
    this.entityrooturl = '/admin/flagcategories';
  }

}
